import React from "react";

export default function StatusDropdown({
  className = "form-select",
  activeLabel = "Active",
  inactiveLabel = "Inactive",
  ...selectProps
}) {
  return (
    <select {...selectProps} className={`${className} np-status-dropdown`}>
      <option value="ACTIVE">{activeLabel}</option>
      <option value="INACTIVE">{inactiveLabel}</option>
    </select>
  );
}
